/**
 * Utility functions for linking into native messaging applications (currently SMS and WhatsApp) without prepoluating a phone number.
 *
 * Plinks is based on this blog post I wrote earlier this year:
 * http://blog.julianklotz.de/2015/03/14/the-sms-uri-scheme/
 *
 * MIT license.
 */

window.plinks = function () {
  "use strict";

  var exports = {};

  var isIosDevice = (function () {
    var ua = navigator.userAgent.toLowerCase();
    return !!(ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1);
  })();

  /**
   * Call plinks.smsLink('myMessage') to get a proper SMS link href
   * The phone number cannot be pre-populated.
   */
  exports.smsLink = function (message) {
    var msg = encodeURIComponent(message),
      href;

    // No more support for iOS 6 + 7
    if (isIosDevice) {
      href = "sms:&body=" + msg;
    } else {
      href = "sms:?body=" + msg;
    }

    return href;
  };

  exports.whatsAppLink = function (message) {
    var msg = encodeURIComponent(message),
      href;
    href = "whatsapp://send?text=" + msg;

    return href;
  };

  return exports;
}.call(this);
